import { isNativeApp, native } from './native'

/**
 * Save a file the page built or fetched. In the Android app it goes to the
 * phone's Downloads (a blob link does nothing in a WebView); in a browser it
 * downloads as usual.
 */
export async function saveBlob(blob: Blob, name: string): Promise<void> {
  if (isNativeApp()) {
    await native.saveFile(blob, name, /\.(pdf|png|jpe?g)$/i.test(name))
    return
  }

  const href = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = href
  a.download = name
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(href), 1000)
}

/** Print the current page (labels, bills): the system print dialog either way. */
export function printPage(title = document.title): void {
  if (isNativeApp()) {
    void native.printPage(title)
    return
  }
  window.print()
}
